// const ReusableModal = ({ isOpen, onClose, title, children }) => {
//   if (!isOpen) return null;

//   return (
//     <>
//       {/* Modal Backdrop */}
//       <div
//         className="modal-backdrop fade show"
//         style={{
//           zIndex: 3000, // higher than header/sidebar
//           position: "fixed",
//         }}
//         onClick={onClose}
//       ></div>

//       {/* Modal Wrapper */}
//       <div
//         className="modal fade show d-block"
//         tabIndex="-1"
//         role="dialog"
//         style={{
//           zIndex: 3100, // also above everything
//           position: "fixed",
//           top: 0,
//           left: 0,
//           width: "100vw",
//           height: "100vh",
//         }}
//       >
//         <div className="modal-dialog modal-fullscreen" role="document">
//           <div className="modal-content">

//             {/* Header */}
//             <div className="modal-header">
//               <h5 className="modal-title">{title}</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 aria-label="Close"
//                 onClick={onClose}
//               ></button>
//             </div>

//             {/* Body */}
//             <div className="modal-body">{children}</div>

//             {/* Footer */}
//             <div className="modal-footer">
//               <button type="button" className="btn btn-secondary" onClick={onClose}>
//                 Close
//               </button>
//             </div>

//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ReusableModal;
const ReusableModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{
          zIndex: 3000,
          position: "fixed",
        }}
        onClick={onClose}
      ></div>

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{
          zIndex: 3100,
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
        }}
      >
        <div
          className="modal-dialog"
          role="document"
          style={{
            maxWidth: "70vw",
            width: "70vw",
            height: "100vh",
            margin: "auto",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            className="modal-content"
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                overflowY: "auto",
                flex: 1,
              }}
            >
              {children}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReusableModal